module.exports = __webpack_public_path__ + "img/Vendor_Logo.50a66cc6.svg";